import { render, staticRenderFns } from "./BestMomentsBlock.vue?vue&type=template&id=76ab8ade&scoped=true"
import script from "./BestMomentsBlock.vue?vue&type=script&lang=js"
export * from "./BestMomentsBlock.vue?vue&type=script&lang=js"
import style0 from "./BestMomentsBlock.vue?vue&type=style&index=0&id=76ab8ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ab8ade",
  null
  
)

export default component.exports